module.exports = __webpack_public_path__ + "img/fran-smc.2115efbc.jpg";